import { logger } from '@nykaa/logger';

export const getPageSource = () => {
  try {
    const url = window.location.href;
    const parsedUrl = new URL(url);
    const source = parsedUrl.searchParams.get('source');
    if (source) {
      return source;
    }
    if (parsedUrl.searchParams.get('utm_source')) {
      return 'deeplink';
    }
    return '';
  } catch (error) {
    logger.error(error as Error, 'Error getting page source');
    return '';
  }
};

export const gotoUrl = (url: string) => {
  if (top?.window && window.self !== window.top) {
    const location = top?.window.location;
    location.href = url;
  }
  window.location.href = url;
};
